module.exports = __webpack_public_path__ + "img/Analytic_process_green.2dff337e.svg";